import React from 'react';

export default function OpenConfirmationModal({ isOpen, onClose, onConfirm, itemName }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[130] p-4 transition-all animate-in fade-in">
            <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-md border border-white/10 dark:border-white/5">
                {/* Modal Header */}
                <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 dark:border-slate-800">
                    <div className="flex items-center gap-3">
                        <div className="p-2.5 bg-blue-100 dark:bg-blue-900/30 rounded-2xl">
                            <span className="material-symbols-outlined text-blue-600 dark:text-blue-400 text-[24px] fill-1">info</span>
                        </div>
                        <div>
                            <h2 className="text-lg font-bold text-gray-900 dark:text-white tracking-tight">Ürünü Aç</h2>
                            <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">SKT Güncellemesi</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-slate-800 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-white transition-all"
                    >
                        <span className="material-symbols-outlined text-[24px]">close</span>
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-4 sm:p-6">
                    <div className="text-center">
                        <p className="text-gray-700 dark:text-gray-300 mb-4 font-medium leading-relaxed">
                            <strong className="text-gray-900 dark:text-white font-bold">{itemName}</strong> paket olarak mutfağınıza eklenmiş.
                        </p>
                        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                            Ürünü sistem dışında açıp kullandıysanız <strong className="text-gray-700 dark:text-gray-300">Son Kullanma Tarihi (SKT)</strong> otomatik olarak değişecektir.
                            <br /><br />
                            Onaylıyor musunuz?
                        </p>
                    </div>
                </div>

                {/* Modal Footer */}
                <div className="flex items-center justify-end gap-3 p-4 sm:p-6 border-t border-gray-200 dark:border-slate-800">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white font-bold transition-colors"
                    >
                        Hayır (İptal)
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl shadow-lg shadow-blue-600/20 active:scale-95 transition-all"
                    >
                        Evet (Onayla)
                    </button>
                </div>
            </div>
        </div>
    );
}
